"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _hooks = require("../../hooks");
var useStyles = function useStyles() {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    basicFontSize = _useContext.basicFontSize,
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView,
    viewHeight = _useDeviceData.viewHeight;
  var ccTaskManagerStyle = (0, _react.useMemo)(function () {
    var ccTaskManager = (0, _css.css)({
      fontFamily: fontFamily,
      userSelect: 'none'
    });
    var ccTaskManagerFullItem = (0, _css.css)({
      height: isMobileView ? '100%' : "calc(".concat(viewHeight + 'px', " - ").concat(pxToRem(62), ")"),
      display: 'flex',
      flexDirection: 'column'
    });
    var ccTaskManagerSubtitle = (0, _css.css)({
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    });
    var ccTaskManagerError = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      height: '100%',
      fontSize: basicFontSize
    });
    var ccTaskManagerErrorImgWrapper = (0, _css.css)({
      flexGrow: 1,
      textAlign: 'center'
    });
    var ccTaskManagerErrorImg = (0, _css.css)({
      height: pxToRem(140)
    });
    var ccTaskManagerSavingTaskTitle = (0, _css.css)({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    });
    var ccTaskManagerSavingTaskSchedule = (0, _css.css)({
      display: 'flex',
      gap: 20,
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& > span:first-child': {
          fontWeight: 'bold'
        }
      }
    });
    var ccTaskManagerSavingTaskScheduleSpacer = (0, _css.css)({
      width: pxToRem(1),
      background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border,
      margin: "0 ".concat(pxToRem(8))
    });
    var ccTaskManagerSavingTaskGroupsAndStudents = (0, _css.css)({
      span: {
        '&::after': {
          content: "', '"
        },
        '&:nth-last-child(1)::after': {
          content: "''"
        }
      }
    });
    var ccTaskManagerSavingTaskFooter = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      flexGrow: 1
    });
    return {
      ccTaskManager: ccTaskManager,
      ccTaskManagerFullItem: ccTaskManagerFullItem,
      ccTaskManagerSubtitle: ccTaskManagerSubtitle,
      ccTaskManagerError: ccTaskManagerError,
      ccTaskManagerErrorImgWrapper: ccTaskManagerErrorImgWrapper,
      ccTaskManagerErrorImg: ccTaskManagerErrorImg,
      ccTaskManagerSavingTaskTitle: ccTaskManagerSavingTaskTitle,
      ccTaskManagerSavingTaskSchedule: ccTaskManagerSavingTaskSchedule,
      ccTaskManagerSavingTaskScheduleSpacer: ccTaskManagerSavingTaskScheduleSpacer,
      ccTaskManagerSavingTaskGroupsAndStudents: ccTaskManagerSavingTaskGroupsAndStudents,
      ccTaskManagerSavingTaskFooter: ccTaskManagerSavingTaskFooter
    };
  }, [basicFontSize, fontFamily, isMobileView, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border, viewHeight]);
  return {
    'cc-TaskManager': ccTaskManagerStyle.ccTaskManager,
    'cc-TaskManager__full-item': ccTaskManagerStyle.ccTaskManagerFullItem,
    'cc-TaskManager__subtitle': ccTaskManagerStyle.ccTaskManagerSubtitle,
    'cc-TaskManager__error': ccTaskManagerStyle.ccTaskManagerError,
    'cc-TaskManager__error__image-wrapper': ccTaskManagerStyle.ccTaskManagerErrorImgWrapper,
    'cc-TaskManager__error__image': ccTaskManagerStyle.ccTaskManagerErrorImg,
    'cc-TaskManager__saving-task__title': ccTaskManagerStyle.ccTaskManagerSavingTaskTitle,
    'cc-TaskManager__saving-task__schedule': ccTaskManagerStyle.ccTaskManagerSavingTaskSchedule,
    'cc-TaskManager__saving-task__schedule__spacer': ccTaskManagerStyle.ccTaskManagerSavingTaskScheduleSpacer,
    'cc-TaskManager__saving-task__groups-and-students': ccTaskManagerStyle.ccTaskManagerSavingTaskGroupsAndStudents,
    'cc-TaskManager__saving-task__footer': ccTaskManagerStyle.ccTaskManagerSavingTaskFooter
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;